const header = {
    // all the properties are optional - can be left empty or deleted
    homepage: '/',
    title: 'Home',
}

const about = {
    // all the properties are optional - can be left empty or deleted
    name: 'Esmaeil Sadeghi',
    role: 'Software Architect',
    // description: 'Software developer & architecture in object-oriented analysis and overseeing all facets of software development life cycle, from analysis and design to implementation and maintenance. Diverse experience utilizing tools in N-tier and Microservices architecture applications using Spring Boot, Spring Cloud config, Netflix OSS components(Eureka, Zuul, Hystrix), Pivotal Cloud Fundry, AWS, Rabbit MQ, Kafka, Zookeeper, Cassandra, MongoDB, Redis, Restful Web Services.',
    // description: 'Software developer & architecture in object-oriented analysis and overseeing all facets of software development life cycle, from analysis and design to implementation and maintenance.',
    // description: 'مدرس، مشاور و معمار  نرم افزار در تجزیه و تحلیل شی گرا و نظارت بر تمام جنبه های چرخه عمر توسعه نرم افزار، از تجزیه و تحلیل و طراحی تا اجرا و نگهداری',

    // description: 'مدرس، مشاور و معمار نرم‌افزار در حوزه تجزیه و تحلیل شی‌گرا و نظارت بر تمامی جنبه‌های چرخه عمر توسعه نرم‌افزار. ارائه خدمات مشاوره حرفه‌ای و راهنمایی در مسیر برنامه‌نویسی، طراحی و اجرای پروژه‌های نرم‌افزاری، و برگزاری دوره‌های آموزشی تخصصی در حوزه فناوری اطلاعات. همچنین، مشاوره و راهنمایی در زمینه مهاجرت و کاریابی در دنیای برنامه‌نویسی و صنعت نرم‌افزار',
    description: 'مدرس، مشاور و معمار نرم‌افزار با تخصص در تجزیه و تحلیل شی‌گرا و مدیریت چرخه عمر توسعه نرم‌افزار. ارائه خدمات مشاوره و هدایت حرفه‌ای در برنامه‌نویسی، طراحی و اجرای پروژه‌های نرم‌افزاری، و برگزاری دوره‌های تخصصی. مشاوره در زمینه مهاجرت و کاریابی در صنعت نرم‌افزار',
    // description: 'Software Developer & Architecture in object-oriented analysis and overseeing all facets of software development life cycle, from analysis and design to implementation and maintenance. Diverse experience utilizing tools in N-tier and Microservices architecture applications using Spring Boot, Spring Cloud config, Netflix OSS components(Eureka, Zuul, Hystrix), Pivotal Cloud Fundry, AWS, Rabbit MQ, Kafka, Zookeeper, Kubernetes ,Docker, Cassandra, MongoDB, Redis, Restful Web Services.',
    // description: 'توسعه دهنده و معمار نرم افزار و نظارت بر تمام جنبه های چرخه عمر نرم افزار از تجزیه, تحلیل و طراحی تا اجرا و نگهداری.',
    // resume: 'https://example.com',
    resume: 'https://drive.google.com/file/d/12IhN2PA4XfKusQcYEc-rBu9QMLVCV5JB/view?usp=sharing',
    aptitude: 'question',
    social: {
        linkedin: 'https://www.linkedin.com/in/dr-esmaeil-sadeghi/',
        github: 'https://github.com/esmaeilsadeghijob?tab=repositories',
        instagram: 'https://www.instagram.com/dr.esmail.sadeghi.h/',
        twitter: 'https://twitter.com/EsmailSadeghih',
        facebook: 'https://www.facebook.com/ismailsadeghi1',
        skype: 'https://join.skype.com/invite/j5ppNeQcRfnQ',
        stackOverflow: 'https://stackoverflow.com/users/9748774/ismael/',
        telegram: '#',
        apple: '#',
        yahoo: '#',
        whatsApp: 'https://wa.link/4yr34g',
        google: '#',
    },
    animated: {
        // first: "I'm software engineer",
        // second: "I'm university professor",
        // third: "I'm a web designer and developer ",
        // first: "مدرس دانشگاه، آموزش و تدریس تخصصی",
        // second: "مشاوره و راهنمایی حرفه‌ای در مسیر برنامه‌نویسی",
        // third: "طراحی و اجرای پروژه‌های نرم‌افزاری",
        // fourth: "برگزاری دوره‌های آموزشی تخصصی در حوزه فناوری اطلاعات",
        first: "University instructor, specialized teaching and education",
        second: "Professional consultation and guidance in programming",
        third: "Design and implementation of software projects",
        // fourth: "Conducting specialized training courses in the field of information technology",
    },
}

const aboutpersion = {
    // titled: "وب سایت شخصی",
    titled: "وب سایت تخصصی",
    namepersion: "اسماعیل ",
    lastname: "صادقی",
    suffix: "  هفشجانی",
    prefix: "دکتر "
}

const projects = [
    // projects can be added an removed
    // if there are no projects, Projects section won't show up
    {
        // name: 'Formal Languages and Automata',
        name: 'نظریه زبان ها و ماشین ها',
        // description:
        //     'A formal language can be specified either by a set of rules that generates the language, or by a formal machine that accepts the language.',
        description:
            'نظریه زبان‌ها و ماشین‌ها یکی از دروس اصلی در حوزه کامپیوتر است که در آن به سه موضوع زبان، گرامر و ماشین، پرداخته می‌شود. این درس پیش‌نیاز درس طراحی کامپایلر است. با یادگیری زبان‌ها و گرامرها، نحوه کار کامپایلر و همچنین طراحی زبان‌های برنامه‌سازی را متوجه خواهید شد',
        // stack: ['Book', 'Document'],
        stack: ['کتاب', 'داکیومنت', 'جزئیات'],
        book: 'https://drive.google.com/drive/folders/1MO85xDagBZRP31T7HdmOJHYbWDvhFaqf?usp=sharing',
        document: 'https://drive.google.com/drive/folders/1VgnDs33kI2dhmxQEALSQsopyNFTRyomY?usp=sharing',
        // application: 'https://www.oracle.com/java/technologies/downloads/',
        details: "automaton"
    },
    {
        // name: 'Software Engineering',
        name: 'مهندسی نرم افزار',
        // description:
        //   'Software engineering is a systematic engineering approach to software development.',
        description:
            'مهندسی نرم‌افزار یک روش سیستماتیک، منظم و دقیق برای توسعه و ارائه محصولی نرم‌افزاری با کیفیت است. مهندسی نرم‌افزار اغلب شامل فرایند خطی تحلیل، طراحی، پیاده‌سازی و آزمون است، که با به‌کارگیری روش‌های فنی و علمی از علوم مهندسی موجب توسعه نرم‌افزاری با کیفیت مطلوب در طول یک فرایند انتخابی مناسب پروژه می‌شود\n',
        // stack: ['SASS', 'TypeScript', 'React'],
        // stack: ['Book', 'Document', 'Visual Paradigm '],
        stack: ['کتاب', 'داکیومنت', 'ویژوال پارادایم'],
        book: 'https://drive.google.com/file/d/1JP7Gg383sJ18WQoER2v3Vq4Bro7VBeEz/view?usp=sharing',
        document: 'https://drive.google.com/drive/folders/1umt8dbblzrODWQOV4c9Lox_-VbBpzm7Q?usp=sharing',
        application: "https://www.visual-paradigm.com/download/?platform=linux&arch=64bit",
    },
    {
        // name: 'Software Engineering',
        name: 'اصول طراحی کامپایلر',
        // description:
        //   'Software engineering is a systematic engineering approach to software development.',
        description:
            'اصول طراحی کامپایلر یکی از دروس اصلی مهندسی کامپیوتر است که در آن با ساختار و مراحل مختلف طراحی و پیاده‌سازی کامپایلر آشنا می‌شوید و نحوه ترجمه برنامه‌های نوشته‌شده به زبان‌های برنامه‌سازی، شناسایی خطاها و چگونگی عملکرد کامپایلر را درک خواهید کرد \n',
        // stack: ['SASS', 'TypeScript', 'React'],
        // stack: ['Book', 'Document', 'Visual Paradigm '],
        stack: ['کتاب', 'داکیومنت'],
        book: 'https://drive.google.com/drive/folders/1dBbJbV4oWW89sxGnFMlQV8-nHfsfjro2?usp=sharing',
        document: 'https://drive.google.com/drive/folders/1uJq5fCcuMocfqIXlBRc11riXzbUwZcbb?usp=sharing',
        application: '',
    },
    {
        // name: 'Fundamentals of Information Technology',
        name: 'مبانی فناوری اطلاعات',
        description:
            'هدف اصلی این است که فناوری اطلاعات را به زبانی ساده به همه دانشجویان مقطع کارشناسی بدون توجه به تخصص آنها معرفی کنیم. این درس به آنها کمک می کند تا برنامه های تخصصی را دنبال کنند که منجر به مشاغل فنی و حرفه ای و مدارک هایی در صنعت IT می شود',
        // description:
        //   'The course objective is to introduce IT in a simple language to all undergraduate students, regardless of their specialization.',
        // stack: [ 'Document'],
        stack: ['داکیومنت'],
        book: '',
        document: 'https://drive.google.com/drive/folders/18lF3HsbdYQwl67IZqoAz4C-1ogeCwiUr?usp=sharing',
        application: '',
    },
    {
        // name: 'Fundamentals of Information Technology',
        name: 'طراحی زبان‌های برنامه‌سازی',
        description:
            'در درس طراحی زبان‌های برنامه‌سازی با اصول و معیارهای طراحی یک زبان آشنا می‌شوید. مباحثی مثل نحو و معنا، سیستم نوع و انواع داده، محدوده و طول عمر متغیرها، کامپایل/تفسیر، مدیریت حافظه، کنترل جریان و پارادایم‌های برنامه‌نویسی بررسی می‌شود. هدف درس، تحلیل و ارزیابی زبان‌ها و آشنایی با طراحی اجزای اصلی یک زبان است.' ,
        // description:
        //   'The course objective is to introduce IT in a simple language to all undergraduate students, regardless of their specialization.',
        // stack: [ 'Document'],
        stack: ['کتاب','داکیومنت'],
        book: 'https://drive.google.com/drive/folders/1jYj1E-Ce3ndbAo2B42sxXOAZr4W24L2U?usp=drive_link',
        document: 'https://drive.google.com/drive/folders/1FfY1Gt_J_PEGPEa-MDq37rJjEHBn9EZG?usp=drive_link',
        application: '',
    },
    {
        // name: 'System Programming',
        // name: 'برنامه نویسی سیستمی',
        // description:
        //     'System programming involves designing and writing computer programs that allow the computer hardware to interface with the user, leading to the effective execution of application software on the computer system.',
        name: 'برنامه نویسی سیستمی',
        description:
            'برنامه نویسی سیستم شامل طراحی و نوشتن برنامه های کامپیوتری است که به سخت افزار کامپیوتر اجازه می دهد تا با کاربر ارتباط برقرار کند و منجر به اجرای موثر نرم افزار کاربردی بر روی سیستم کامپیوتری شود',
        // stack: ['SASS', 'TypeScript', 'React'],
        // stack: ['Book', 'Document', 'Android Studio'],
        stack: ['داکیومنت'],
        book: '',
        document: 'https://drive.google.com/drive/folders/1TMsPyXv7_SVZPhO_UfQrROHSE9SO4_Vm?usp=sharing',
        application: "",
    },
    {
        // name: 'Software Engineering',
        name: 'مبانی کامپیوتر و برنامه سازی',
        // description:
        //   'Software engineering is a systematic engineering approach to software development.',
        description:
            'درس مبانی کامپیوتر و برنامه‌سازی به دانشجویان اصول اولیه کامپیوتر و برنامه‌نویسی را آموزش می‌دهد. این درس شامل مباحثی مانند ساختارهای داده‌ای، الگوریتم‌ها، زبان‌های برنامه‌نویسی، و مفاهیم پایه‌ای برنامه‌نویسی است. هدف این درس، ایجاد پایه‌ای قوی برای دانشجویان در زمینه برنامه‌نویسی و حل مسائل محاسباتی است.\n',
        // stack: ['SASS', 'TypeScript', 'React'],
        // stack: ['Book', 'Document', 'Visual Paradigm '],
        stack: ['کتاب', 'داکیومنت', 'کامپایلر'],
        book: 'https://drive.google.com/drive/folders/18mCAVn5UU9MkFuLY0PrZyyqsY4Jalrha?usp=sharing',
        document: 'https://drive.google.com/drive/folders/1lSLf9xMA1aI9QlPEvK_cd4ZFN6LI7VcP?usp=sharing',
        application: "",
        // tools: "https://www.programiz.com/cpp-programming/online-compiler"
        tools: "https://www.onlinegdb.com/online_c++_compiler"
    },
    {
        // name: 'Software Engineering',
        name: 'الگوریتم',
        // description:
        //   'Software engineering is a systematic engineering approach to software development.',
        description:
            'درس طراحی الگوریتم به آموزش شیوه‌های منطقی و مرحله‌مند برای حل مسائل می‌پردازد. در این درس، دانشجویان با اصول طراحی و ارزیابی الگوریتم‌ها، مفاهیم بازگشت، روش‌های مرتب‌سازی و جست‌وجو، و الگوریتم‌های مرتبط با گراف‌ها آشنا می‌شوند. هدف اصلی، پرورش توانایی تفکر الگوریتمی و ارائه راه‌حل‌های مؤثر برای مسائل محاسباتی است.\n',
        // stack: ['SASS', 'TypeScript', 'React'],
        // stack: ['Book', 'Document', 'Visual Paradigm '],
        stack: ['کتاب', 'داکیومنت'],
        book: 'https://drive.google.com/drive/folders/17ySrmGDPwHQrz5wVri3OAFE4iW2E_1Dz?usp=sharing',
        document: 'https://drive.google.com/drive/folders/19bBGZmzpPZ1KoO7pyVq-fWKkcy257vzS?usp=sharing',
        application: "",
        // tools: "https://www.programiz.com/cpp-programming/online-compiler"
        tools: ""
    },
    {
        // name: 'Blockchain',
        name: ' بلاک‌ چین',
        // description:
        //   'Blockchain is a popular and quickly expanding technology that offers freedom and security over the internet for people worldwide.',
        description:
            ' دوره آموزشی بلاک چین، اصول اولیه بلاک چین مانند نحوه عملکرد بلاک چین و کاربردهای آن را پوشش می دهد. در این آموزش دانشجویان ارزهای دیجیتال را نیز مطالعه می کنند، مشکلاتی را شناسایی کنند که با استفاده از فناوری بلاک چین توسعه یافته توسط سازمان هایی مانند Hyperledger قابل حل می باشد',
        // stack: ['Book', 'Document', 'Solidity'],
        stack: ['کتاب'],
        book: 'http://book.itep.ru/depository/blockchain/blockchain-by-melanie-swan.pdf',
        document: '',
        application: '',
    },
    {
        // name: 'Microservices',
        name: 'معماری کامپیوتر',
        // description:
        //     'Microservices is a growing standard in cloud based software design, used by several companies today.We offer microservices training that can meet your needs..',
        description:
            'معماری کامپیوتر مجموعه ای از قوانین و سیستم هایی است که نحوه عملکرد یک سیستم کامپیوتری را کنترل می کند. این شامل اجزای مختلفی از جمله معماری مجموعه دستورالعمل، ریزمعماری و پیاده سازی می باشد',
        stack: ['داکیومنت'],
        book: '',
        document: 'hhttps://en.wikipedia.org/wiki/Computer_architecture',
        application: '',
    },
    {
        // name: 'Logic Circuits',
        name: 'مدار منطقی',
        // description:
        //     'Combinational Logic Circuits: Design Methods, Adders, Subtractors , Code Conversion , Analysis Procedure , EOR & ENOR Gates Applications.',
        description:
            'مدارهای منطقی شامل روش‌های طراحی، جمع‌کننده‌ها، تفریق‌کننده‌ها، تبدیل کد، روش تحلیل، برنامه‌های مختلف جهت تحلیل و طراحی سیستم های دیجیتال است',
        stack: ['داکیومنت', 'دانلود'],
        book: '',
        document: 'https://drive.google.com/drive/folders/1arat0nVLfPY7y-C2ClsHQBh8SX11-E-M?usp=share_link',
        application: 'https://www.labcenter.com/downloads/',
    },
    {
        // name: 'Logic Circuits',
        name: 'صنعت کامپیوتر',
        // description:
        //     'Combinational Logic Circuits: Design Methods, Adders, Subtractors , Code Conversion , Analysis Procedure , EOR & ENOR Gates Applications.',
        description:
            'درس آشنایی با صنعت کامپیوتر به بررسی ساختار، نقش‌ها، فناوری‌ها و روندهای رایج در حوزه کامپیوتر و فناوری اطلاعات می‌پردازد. هدف این درس، ایجاد دیدگاهی جامع نسبت به فرصت‌های شغلی و مسیرهای حرفه‌ای در صنعت کامپیوتر است',
        stack: ['داکیومنت', 'دانلود'],
        book: 'https://drive.google.com/drive/folders/1-SdwGhWquIMIpNkghLILQtLTfx1JvvRx?usp=sharing',
        document: 'https://drive.google.com/drive/folders/1lFs1XzZfT5RUNfh-Fk2jDe91ttzoREgk?usp=sharing',
        application: '',
    },
    {
        // name: 'Microservices',
        name: 'میکروسرویس‌',
        // description:
        //     'Microservices is a growing standard in cloud based software design, used by several companies today.We offer microservices training that can meet your needs..',
        description:
            'در مهندسی نرم‌افزار، معماری میکروسرویس یک الگوی معماری است که یک برنامه کاربردی را به‌عنوان مجموعه‌ای از سرویس‌های ریز به‌هم‌پیوسته و مرتب که از طریق پروتکل‌های سبک‌وزن ارتباط برقرار می‌کند.',
        stack: ['داکیومنت'],
        book: '',
        document: 'https://microservices.io/',
        application: '',
    },
    {
        // name: 'Spring',
        name: 'پایتون',
        // description:
        //   'Core Spring Training. This course offers hands-on experience with Spring (Spring Boot, Spring Cloud) and its major features, including configuration, data access, web and REST applications, testing, AOP and security.',
        description:
            'پایتون یک زبان برنامه‌نویسی ساده، خوانا و قدرتمند است که کاربرد گسترده‌ای در حوزه‌های مختلف از جمله هوش مصنوعی، یادگیری ماشین و تحلیل داده دارد. به دلیل سینتکس روان و کتابخانه‌های متنوع، یادگیری آن برای مبتدیان آسان و برای حرفه‌ای‌ها بسیار کاربردی است.\n',
        stack: ['کتاب', 'داکیومنت', 'دانلود'],
        book: 'https://drive.google.com/drive/folders/1bjOThvnAWgjp3GcD88i9CLm6mIbmicDx?usp=sharing',
        document: 'https://drive.google.com/drive/folders/1DWr0OlIkdwCFx9uw1rb6Nuknkpt6GUKt?usp=sharing',
        application: 'https://www.python.org/downloads/',
    },
    {
        // name: 'Spring',
        name: 'اسپرینگ',
        // description:
        //   'Core Spring Training. This course offers hands-on experience with Spring (Spring Boot, Spring Cloud) and its major features, including configuration, data access, web and REST applications, testing, AOP and security.',
        description:
            'اسپرینگ فریمورک یک چارچوب کاربردی و وارونگی کانتینر کنترل برای پلتفرم جاوا است. ویژگی های اصلی این فریم ورک را می توان توسط هر برنامه جاوا استفاده کرد، و افزونه هایی برای ساخت برنامه های وب برای پلت فرم Java EE شامل می شود',
        stack: ['کتاب', 'سرفصل', 'ابزار'],
        book: 'https://drive.google.com/drive/folders/1-XY02zTmftbtU7QrCPtB883c3gGM9NID?usp=sharing',
        document: 'https://drive.google.com/drive/folders/15UO4bsvZpW3AVnSvCMhrIGFOIodffDZO?usp=sharing',
        application: 'https://spring.io/tools',
    },
    {
        // name: 'DevOps',
        name: 'دواپس ',
        // description:
        //     'DevOps is a methodology in the software development and IT industry. Used as a set of practices and tools, DevOps integrates and automates the work of software development and IT operations as a means for improving and shortening the systems development life cycle.',
        description:
            'دواپس مجموعه‌ای از شیوه‌ها، ابزارها و یک فلسفه فرهنگی است که فرآیندهای بین تیم‌های توسعه نرم‌افزار و فناوری اطلاعات را خودکار و یکپارچه می‌کند. بر توانمندسازی تیم، ارتباطات و همکاری بین تیمی و اتوماسیون فناوری تاکید دارد',
        stack: ['داکیومنت'],
        // book: 'https://drive.google.com/file/d/14rZlzaTJHHpmYLY1Kx5t7xGScoJEY9f5/view?usp=sharing',
        document: 'https://drive.google.com/drive/folders/1LO86N5jjUgW9247IHy69j2kP-GhSCzmF?usp=sharing',
        // application: 'https://www.oracle.com/java/technologies/downloads/',
    },
    {
        // name: 'Mobile',
        name: 'موبایل',
        // description:
        //     'Android is a mobile operating system based on a modified version of the Linux kernel and other open-source software, designed primarily for touchscreen mobile devices such as smartphones and tablets.',
        description:
            'اندروید یک سیستم عامل تلفن همراه است که بر اساس نسخه اصلاح شده هسته لینوکس و سایر نرم افزارهای منبع باز، عمدتاً برای دستگاه های تلفن همراه با صفحه لمسی مانند تلفن های هوشمند و تبلت ها طراحی شده است',
        // stack: ['SASS', 'TypeScript', 'React'],
        // stack: ['Book', 'Document', 'Android Studio'],
        stack: ['داکیومنت', 'دانلود'],
        book: '',
        // document: 'https://developer.android.com/docs',
        document: 'https://drive.google.com/drive/folders/1P2fp2Dh2P8icC9ADx4w-ADzjTVSDO5ve?usp=sharing',
        application: "https://developer.android.com/studio",
    },
    {
        // name: 'Java',
        name: 'جاوا',
        // description:
        //     'This course of study builds on the skills gained by students in Java Fundamentals or Java Foundations to help advance Java programming skills.',
        description:
            'جاوا یک زبان برنامه نویسی سطح بالا، مبتنی بر کلاس و شی گرا است که به گونه ای طراحی شده است که تا حد امکان وابستگی های پیاده سازی کمتری داشته باشد',
        // stack: ['Book', 'Document', 'JDK'],
        stack: ['کتاب', 'داکیومنت', 'دانلود', 'جزئیات'],
        book: 'https://drive.google.com/drive/folders/185nxYcB07OVNg0xlkCyIQ70o5Z-25mHt?usp=sharing',
        document: 'https://drive.google.com/drive/folders/1vh1o_94OMyY6Ohi-JDp1610De5Q8OhtK?usp=sharing',
        application: 'https://www.oracle.com/java/technologies/downloads/',
        details: 'java',
    },
    {
        name: 'نود جی اس',
        // description:
        //     'A Node.js course is a great way to enter into web and mobile development. It can be used to build apps at any scale and is widely used to create applications of every sor.',
        description:
            'نود جی‌اس یک محیط اجرایی برای زبان جاوا اسکریپت است که بصورت متن باز ارائه شده است و می تواند روی ویندوز، لینوکس، یونیکس، macOS و غیره اجرا شود. Node.js روی موتور جاوا اسکریپت V8 اجرا می شود و کد جاوا اسکریپت را خارج از مرورگر وب اجرا می کند. Node.js به توسعه دهندگان اجازه می دهد از جاوا اسکریپت برای نوشتن ابزارهای خط فرمان و برای اسکریپت نویسی سمت سرور استفاده کنند',
        stack: ['داکیومنت', 'دانلود'],
        book: '',
        document: 'https://nodejs.org/en/docs/',
        application: 'https://nodejs.org/en/download/',
    },
    {
        // name: 'React JS',
        name: 'ری اکت',
        // description:
        //     'React is a free and open-source front-end JavaScript library for building user interfaces based on components.',
        description:
            'ری اکت جی اس یک کتابخانه جاوا اسکریپت فرانت‌اند رایگان و منبع باز برای ساخت رابط‌های کاربری بر اساس مؤلفه‌های فیس‌بوک است. این کتابخانه توسط جامعه‌ای از توسعه‌دهندگان و شرکت‌ها نگهداری می‌شود. React را می توان برای توسعه برنامه های تک صفحه ای، تلفن همراه یا رندر شده توسط سرور با چارچوب هایی مانند Next.js استفاده کرد',
        stack: ['کتاب', 'داکیومنت'],
        book: 'https://drive.google.com/drive/folders/1zbgXv9jfFzsNfASsBgWBCrINi64O7Ssn?usp=sharing',
        document: 'https://drive.google.com/drive/folders/1OhVRmj8lN6srvuFK90sSOjEOyQGhPOgs?usp=sharing',
        // application: 'https://www.oracle.com/java/technologies/downloads/',
    },
    {
        // name: 'SharePoint',
        name: 'شیرپوینت ',
        // description:
        //     'SharePoint is a web-based collaborative platform that integrates natively with Microsoft Office.',
        description:
            'شیرپوینت مجموعه ای از ابزارهای مدیریت محتوای سازمانی و مدیریتی که توسط مایکروسافت توسعه یافته است. در سال 2001 راه اندازی شد، ابتدا با ویندوز سرور به عنوان Windows SharePoint Server، سپس به Microsoft Office SharePoint Server تغییر نام داد و در نهایت به SharePoint تغییر نام داد',
        stack: ['داکیومنت', 'دانلود'],
        book: '',
        document: 'https://drive.google.com/drive/folders/1qPGrTs-iuCSkhl-36RjN2zUWf2eVSpJC?usp=sharing',
        application: 'https://dl2.soft98.ir/engineering/Microsoft.SharePoint.Server.2019.x64.rar?1666289430',
    },
    {
        // name: 'SharePoint',
        name: 'گیت',
        // description:
        //     'SharePoint is a web-based collaborative platform that integrates natively with Microsoft Office.',
        description:
            'گیت یک سیستم کنترل نسخه توزیع شده است که نسخه های فایل ها را ردیابی می کند. اغلب برای کنترل کد منبع توسط برنامه نویسانی که در حال توسعه نرم افزار هستند استفاده می شود',
        stack: ['داکیومنت', 'دانلود'],
        book: '',
        document: 'https://git-scm.com/book/en/v2',
        application: 'https://git-scm.com/',
    }
]

const skills = [
    // skills can be added or removed
    // if there are no skills, Skills section won't show up
    "Java",
    'HTML',
    'CSS',
    'JavaScript',
    'TypeScript',
    'React',
    'Redux',
    'SASS',
    'Material UI',
    'Git',
    'CI/CD',
    'Jest',
    'Enzyme',
]

const skillsSrc = [
    {
        name: 'Java',
        image: 'java'
    },
    {
        name: 'HTML',
        image: '../../img/html-5-logo-svgrepo-com.svg'
    },
]

const contact = {
    // email is optional - if left empty Contact section won't show up
    email: 'esmaeilsadeghijob@gmail.com',
    yahoo: 'esmail_sadeghi1@yahoo.com',
    telegram: 'https://t.me/esmaeilsadeghih',
}

const aboutme = {
    name: 'اسماعیل',
    info: '',
}

const carousels = [
    {
       uri: 'https://www.airband.co.uk/wp-content/uploads/2023/04/pexels-thisisengineering-3861972-scaled-e1689167918972-1100x550.jpg'
        // uri: 'https://static.vecteezy.com/system/resources/previews/067/822/618/non_2x/playful-new-year-2026-banner-with-star-and-confetti-elements-in-warm-pastel-background-vector.jpg'

        // uri: 'https://static.vecteezy.com/system/resources/thumbnails/067/892/022/small/2026-happy-new-year-new-years-eve-celebration-greeting-card-new-year-card-year-2026-in-sparkler-background-vector.jpg'
    },
    {
        // uri: 'https://img.freepik.com/free-vector/decorative-2025-new-year-festive-banner-line-art_1017-56391.jpg?semt=ais_hybrid'
        // uri: 'https://img.freepik.com/free-vector/happy-new-year-2025-clock-banner-design_1017-56802.jpg'

        // uri: 'https://learn.uvm.edu/wp-content/uploads/2019/05/CareerCoaching_sm-scaled-1.jpg'
        // uri: "https://i.etsystatic.com/35197480/r/il/01e295/4332567444/il_570xN.4332567444_hdpu.jpg"
        uri: 'https://media-01.imu.nl/storage/5609/13278/responsive/10602335/aan-je-bedrijf-2560x1100_734_315.png'
    },
    // {
    //     uri: 'https://static.vecteezy.com/system/resources/thumbnails/015/641/885/small/international-migrants-day-migration-concept-illustration-illustration-free-vector.jpg'
    // },
    // {
        // uri: 'https://www.future-processing.com/blog/wp-content/uploads/2024/01/cover_ADP.jpg'
        // uri: 'https://paperbell.com/wp-content/uploads/2023/09/client-tracking-feature.png'
        // uri: 'https://www.sonata-software.com/sites/default/files/banner/image/2021-12/digital-consulting-banner-min.png'
    // },
    {
        // uri: 'https://targetjobs.co.uk/static/fd2214e3d88c6fa8a589c055cc04609e/e3554/software-developer.webp'
        uri: "https://paperbell.com/wp-content/uploads/2023/03/how-to-scale-a-coaching-business-feature.png"
        // uri: 'https://wgeco.org/wp-content/uploads/2017/04/innerbanner.png'
    },
    {
        // uri: 'https://www.keyusa.com/images/process-automation-1.jpg'
        // uri: 'https://www.myskillsfuture.gov.sg/content/dam/portal/tex/aot/hero/999_3.jpg'
        uri: 'https://paperbell.com/wp-content/uploads/2023/12/chatgpt-copywriting-feature.jpg'
        // uri: 'https://rdisl.com/assets/img/slider-3.jpg'
    },
    {
        // uri: 'https://jelvix.com/wp-content/uploads/2020/04/cover_2-2.jpg'
        // uri: 'https://www.ags-it.de/wp-content/uploads/2021/10/it-consulting-2.jpg'
        // uri: 'https://paperbell.com/wp-content/uploads/2020/07/termsandconditions-feature1200x429.jpg'
        // uri: 'https://www.anneback.dk/wp-content/uploads/2018/11/Anne_Back270_web.jpg'
        uri: 'https://jelvix.com/wp-content/uploads/2020/04/cover_2-2.jpg'
    }
]

export {header, about, projects, skills, contact, skillsSrc, aboutpersion, carousels, aboutme}
